/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import { Form } from '@ant-design/compatible';
import { ArrowLeft, Erase } from '@carbon/icons-react';
import { Button, Row, Col, Tabs, Modal, Select, Input } from 'antd';
import { isEmpty } from 'underscore';
import moment from 'moment';
import CreateDriverForm from './forms/createDriverForm';
import DriverJourneyHistory from './tabs/driverJourneyHistory';
import DriverJourneyHistoryFilter from './forms/driverJourneyHistoryFilter';
import DriverEventHistoryTab from './tabs/driverEventHistory';
import DriverEventHistoryFilter from './forms/driverEventHistoryFilter';
import DriverManagementAlertsTab from './tabs/driverManagementAlerts';
import DriverServiceAlertsFilter from './forms/driverServiceAlertsFilter';
import DriverPerformance from './tabs/driverPerformance';
import Layout from '../../components/layout/Layout';
import Avatar from '../../components/elements/Avatar';
import FilterSidebar from '../../components/FilterSidebar';
import Icon from '../../components/elements/Icon';
import CustomEmpty from '../../components/CustomEmpty';
import history from '../../core/utils/history';
import StyledList from '../../components/StyledList';
import { UserRole } from '../../types/types';

import './driversView.scss';

const FormItem = Form.Item;
const { Option } = Select;

export default function () {
    const { driver, asset, match, user, isFetchingJourneys } = this.props;
    const {
        selectedAsset,
        currentTabKey,
        journeyHistoryTabLoaded,
        eventsHistoryTabLoaded,
        serviceAlertsTabLoaded,
        deleteDataConfirmButtonVisible,
        isDeleteDataModalVisible,
        displayFilter,
        isExportingDriverEventHistoryCsv,

        driverJourneys,
        driverJourneysPagination,
        journeyHistoryTabFilter,
        isLoadingJourneys,
        isExportingJourneyHistoryCsv,

        driverEvents,
        driverEventsPagination,
        eventsHistoryTabFilter,
        isLoadingEvents
    } = this.state;
    const { driverId } = match.params;

    let filterContent = null;
    let journeyHistoryTabContent = null;
    let eventHistoryTabContent = null;
    let serviceAlertsTabContent = null;
    if (currentTabKey === '1') {
        filterContent = (
            <DriverJourneyHistoryFilter
                driverId={driverId}
                onSubmit={this.onJourneyHistoryTabFilterChange}
            />
        );
        journeyHistoryTabContent = (
            <DriverJourneyHistory
                driverId={driverId}
                driverJourneys={driverJourneys}
                driverJourneysPagination={driverJourneysPagination}
                isLoadingJourneys={isLoadingJourneys}
                isExportingJourneyHistoryCsv={isExportingJourneyHistoryCsv}
                journeyHistoryTabFilter={journeyHistoryTabFilter}
                onPageChange={this.onJourneyHistoryTabPageChange}
                onTableChange={this.onJourneyHistoryTabSortChange}
                setLoadedState={this.setJourneyHistoryTabLoaded}
                journeyHistoryTabLoaded={journeyHistoryTabLoaded}
                onExportJourneyHistoryCSV={this.onExportJourneyHistoryCSV}
            />
        );
    } else if (currentTabKey === '2') {
        filterContent = (
            <DriverEventHistoryFilter
                onSubmit={this.onEventsHistoryTabFilterChange}
                driverId={driverId}
            />
        );
        eventHistoryTabContent = (
            <DriverEventHistoryTab
                driverId={driverId}
                onPageChange={this.onEventsHistoryTabPageChange}
                onTableChange={this.onEventsHistoryTabSortChange}
                setLoadedState={this.setEventsHistoryTabLoaded}
                eventsHistoryTabLoaded={eventsHistoryTabLoaded}
                onExportDriverEventCSV={this.onExportDriverEventCSV}
                eventsHistoryTabFilter={eventsHistoryTabFilter}
                driverEvents={driverEvents}
                isLoadingEvents={isLoadingEvents}
                driverEventsPagination={driverEventsPagination}
                isExportingDriverEventHistoryCsv={isExportingDriverEventHistoryCsv}
            />
        );
    } else if (currentTabKey === '4') {
        filterContent = (
            <DriverServiceAlertsFilter
                onSubmit={this.onServiceAlertsTabFilterChange}
                driverId={driverId}
            />
        );
        serviceAlertsTabContent = (
            <DriverManagementAlertsTab
                driverId={driverId}
                onPageChange={this.onServiceAlertsTabPageChange}
                onTableChange={this.onServiceAlertsTabSortChange}
                setLoadedState={this.setServiceAlertsTabLoaded}
                serviceAlertsTabLoaded={serviceAlertsTabLoaded}
            />
        );
    }

    if (isEmpty(driver.singleDriver)) {
        return (
            <Layout
                className="assets"
                title={<div>Drivers</div>}
                headerTitle={<div>Drivers</div>}
                showFooter={false}
            >
                <div className={`content-wrap${user?.userCompany?.current_alert ? '-with-banner' : ''}`}>
                    <br />
                    <br />
                    <CustomEmpty />
                </div>
            </Layout>
        );
    }

    const isFetching = driver?.isFetching || [];
    const isFetchingDriver = isFetching.some((item) => item.GET_SINGLE_DRIVER);
    const isFetchingTags = isFetching.some((item) => item.TAG_LIMIT_REACHED_REQUEST);
    const isFetchingDriverServiceAlerts = isFetching.some((item) => item.GET_DRIVER_SERVICE_ALERTS);
    let assetName = 'Not Assigned';
    if (driver.singleDriver.asset) {
        if (driver.singleDriver.asset.registration) {
            assetName = driver.singleDriver.asset.registration;
        } else {
            assetName = driver.singleDriver.asset.name;
        }
    }
    const labelValuePairs = [{
        label: 'Name: ',
        value: driver.singleDriver?.profile?.full_name || '-',
    },
    {
        label: 'Driver Licence Type: ',
        value: driver.singleDriver?.licenceType?.title || '-',
    },
    {
        label: 'Division: ',
        value: driver.singleDriver?.division?.name || '-',
    },
    {
        label: 'Daily Distance Covered: ',
        value: driver.singleDriver?.dailyMileage || '-',
    },
    {
        label: 'Total Distance Covered: ',
        value: driver.singleDriver?.totalMileage || '-',
    },
    {
        label: 'Total Hours: ',
        value: driver.singleDriver?.totalHours || '-',
    },
    {
        label: 'Driver Status: ',
        value: driver.singleDriver?.profile?.driver_status || '-',
    },
    {
        label: 'Driver Availability: ',
        value: driver.singleDriver?.profile?.driver_availability == 1 ? 'Available' : 'Not available',
    },
    {
        label: 'Driving Operating Hours: ',
        value: `From ${driver.singleDriver?.profile?.operation_start_time ? moment(driver.singleDriver.profile.operation_start_time, 'HH:mm:ss').format('HH:mm') : '[not-set]'} till ${driver.singleDriver.profile.operation_end_time ? moment(driver.singleDriver.profile.operation_end_time, 'HH:mm:ss').format('HH:mm') : '[not-set]'}`,
    },
    {
        label: 'Registration: ',
        value: assetName || '-',
    },
    {
        label: 'Notes: ',
        value: driver.singleDriver?.profile?.notes || '-',
    }];

    return (
        <Layout
            data-test="pages-drivers-view"
            className="assets"
            title={<div>DriverView</div>}
            headerTitle={<div>DriverView Page</div>}
            showFooter={false}
            loading={
                isFetchingDriver ||
                isFetchingTags ||
                isFetchingDriverServiceAlerts ||
                isFetchingJourneys
            }
        >
            <div className={`content-wrap${user?.userCompany?.current_alert ? '-with-banner' : ''}`}>
                {displayFilter && filterContent ? (
                    <FilterSidebar displayFilter={displayFilter}>{filterContent}</FilterSidebar>
                ) : (
                    <>
                        <br />
                        <br />
                    </>
                )}
                <div className="content" style={{ opacity: isFetchingDriver ? 0 : 1 }}>
                    <div className="content-inner">
                        <section className="section">
                            <div className="section__body">
                                <Row>
                                    <Col span={6}>
                                        {user.permissions.adding_drivers === true ? (
                                            <div style={{ marginLeft: '16px' }}>
                                                <Button
                                                    className='btn-link'
                                                    onClick={() => history.push('/drivers')}
                                                    style={{ verticalAlign: 'middle' }}
                                                    data-testid='driver-details_back-btn'
                                                >
                                                    <ArrowLeft />
                                                    &thinsp;
                                                    Back
                                                </Button>

                                            </div>
                                        ) : null}
                                    </Col>
                                    <Col span={18}>
                                        <span style={{
                                            float: 'right',
                                        }}>
                                            {[UserRole.SuperAdmin, UserRole.Admin, UserRole.Manager, UserRole.SalesAdmin].includes(user.role) && (
                                                <>
                                                    <Button
                                                        type="primary"
                                                        className="btn"
                                                        onClick={this.toggleModalEdit}
                                                        data-testid='driver-details_edit-btn'
                                                    >
                                                        Edit
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        className="btn"
                                                        style={{
                                                            marginLeft: '16px',
                                                        }}
                                                        onClick={this.toggleModalAssign}
                                                        data-testid='driver-details_assign-btn'
                                                    >
                                                        Assign to Asset
                                                    </Button>
                                                    {[UserRole.SuperAdmin, UserRole.Admin, UserRole.SalesAdmin, UserRole.Manager] && (
                                                        <Button
                                                            className="btn btn-bordered"
                                                            style={{
                                                                width: '120px',
                                                                marginLeft: '16px',
                                                            }}
                                                            onClick={this.showModal}
                                                            data-testid='driver-details_delete-data-btn'
                                                        >
                                                            Delete Driver
                                                        </Button>
                                                    )}
                                                </>
                                            )}
                                        </span>
                                        <Modal
                                            icon={null}
                                            title="Are you sure?"
                                            open={isDeleteDataModalVisible}
                                            onOk={this.handleOk}
                                            onCancel={this.handleCancel}
                                            okText="Delete"
                                            okButtonProps={{ disabled: !deleteDataConfirmButtonVisible }}
                                        >
                                            <br />
                                            <p style={{
                                                fontSize: '12px',
                                                textAlign: 'center'
                                            }}>
                                                If you're sure then type 'delete' into the field below and click Delete.
                                            </p>
                                            <p style={{
                                                fontSize: '12px',
                                                textAlign: 'center'
                                            }}>
                                                Driver and Profile data will be deleted.
                                            </p>
                                            <br />
                                            <Input
                                                onChange={(e) => this.saveDeleteText(e.target.value)}
                                                placeholder="Type 'delete'"
                                                style={{ marginBottom: '16px' }}
                                                data-testid='driver-details_delete-data-modal_confirm-input'
                                            />
                                        </Modal>
                                    </Col>
                                </Row>
                                <br />
                                <br />
                                <Row gutter={32}>
                                    <Col
                                        md={24}
                                        xl={12}
                                    >
                                        <StyledList
                                            labelValuePairs={labelValuePairs}
                                            dataTestId='driver-details_styled-list'
                                        />
                                    </Col>
                                    <Col
                                        md={24}
                                        xl={12}
                                    >
                                        <br />
                                        <br />
                                        <Avatar
                                            pictureUrl={driver.singleDriver.profile.profilePictureFull}
                                            onChange={(data) => this.updateDriverPicture(data)}
                                            className="view-driver-avatar-large"
                                            dataTestId='driver-details_avatar-uploader'
                                        />
                                    </Col>
                                </Row>
                                <Tabs
                                    onTabClick={(key) => this.handleTabChange(key)}
                                    defaultActiveKey="1"
                                    animated={false}
                                    className="tabs-restyled2"
                                >
                                    <Tabs.TabPane
                                        tab="journey history"
                                        key="1"
                                        data-testid='driver-details_journeys-tab-btn'
                                    >
                                        <div className="section__body">
                                            {journeyHistoryTabContent}
                                        </div>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane
                                        tab="event history"
                                        key="2"
                                        data-testid='driver-details_events-tab-btn'
                                    >
                                        <div className="section__body">
                                            {eventHistoryTabContent}
                                        </div>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane
                                        tab="management alerts"
                                        key="4"
                                        data-testid='driver-details_management-alerts-tab-btn'
                                    >
                                        <div className="section__body">
                                            {serviceAlertsTabContent}
                                        </div>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane
                                        tab="driver performance"
                                        key="5"
                                        data-testid='driver-details_performance-tab-btn'
                                    >
                                        <div className="section__body">
                                            <DriverPerformance />
                                        </div>
                                    </Tabs.TabPane>
                                </Tabs>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <Modal
                open={this.state.modalAssignToAssets}
                onCancel={this.toggleModalAssign}
                footer={false}
                width={388}
            >
                <div className="d-flex dir-column align-center">
                    <h4
                        className="h-4"
                        style={{ textTransform: 'none' }}
                    >
                        Assign to Asset
                    </h4>
                    <Form layout="vertical" className="mt-4">
                        <FormItem>
                            <Select
                                showSearch
                                allowClear={<Erase size={12} />}
                                style={{ width: '100%' }}
                                placeholder="Select Asset"
                                optionFilterProp="children"
                                defaultValue={
                                    driver.singleDriver.asset ? driver.singleDriver.asset.id : null
                                }
                                onChange={(data) => this.selectAsset(data)}
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                data-testid='driver-details_assign-modal_asset-select'
                            >
                                {!isEmpty(asset.assetList)
                                    ? asset.assetList.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {`${item.name} ${item.registration}`}
                                        </Option>
                                    ))
                                    : null}
                            </Select>
                        </FormItem>
                        <div className="assign-to">
                            <div className="assign-to__item">
                                {driver &&
                                    driver.singleDriver &&
                                    driver.singleDriver.profile &&
                                    driver.singleDriver.profile.profilePictureThumb ? (
                                    <img
                                        src={driver.singleDriver.profile.profilePictureThumb}
                                        alt="Driver"
                                        className="fitted"
                                    />
                                ) : (
                                    <img
                                        src="https://api.monosnap.com/file/download?id=5rqj7D0AkOhSEpIci6p6ThpJovzpCg"
                                        alt="Driver"
                                        className="fitted"
                                    />
                                )}
                            </div>
                            <div className="assign-to__arrow">
                                <Icon name="right-arrow" />
                            </div>
                            <div className="assign-to__item">
                                {isEmpty(selectedAsset) ? (
                                    <h3 style={{ textAlign: 'center' }}>Please select asset</h3>
                                ) : (
                                    <>
                                        {selectedAsset && selectedAsset.pictureThumb ? (
                                            <img
                                                src={selectedAsset.pictureThumb}
                                                alt="Truck"
                                                className="fitted"
                                            />
                                        ) : (
                                            <img
                                                src="https://api.monosnap.com/file/download?id=V5zuJ6UXRXjjblUfezXU1YwEJ7tZ9l"
                                                alt="Truck"
                                                className="fitted"
                                            />
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="mt-4 text-center">
                            <Button
                                onClick={() => this.assignAsset()}
                                htmlType="submit"
                                type="primary"
                                data-testid='driver-details_assign-modal_confirm-btn'
                            >
                                assign to asset
                            </Button>
                        </div>
                    </Form>
                </div>
            </Modal>
            <Modal
                open={this.state.modalEdit}
                onCancel={this.toggleModalEdit}
                className="with-narrow-padding"
                footer={false}
                width={400}
            >
                <div style={{ width: '100%' }}>
                    <CreateDriverForm
                        onSubmit={this.updateDriver}
                        editMode
                    />
                </div>
            </Modal>
        </Layout>
    );
}
